export enum TypesenseCluster {
  Patients = 'patients',
  Tasks = 'tasks',
  WaitLists = 'waitLists',
}
